module.exports = __webpack_public_path__ + "assets/images/b2336242a8b6be381adbb9df8241e997.png";